// Remembers the driver's phone (E.164) across sessions so the OTP / invite
// re-auth screens can prefill it.
//
// Why this exists (GH #502 — "session not persisting for some drivers"): the
// backend session is sound (30-day cookie == 30-day JWT, refreshed on every
// boot) and a dropped session already routes to /auth/phone rather than the
// dead single-use invite screen. But some drivers still lose the cookie — it
// was written into an in-app WhatsApp/SMS webview jar, or an iOS PWA storage
// partition that got evicted. We can't stop every device-side eviction from the
// server, so the pragmatic mitigation is to make recovery frictionless: land on
// the OTP screen with the number already filled, so getting back in is one tap
// + one SMS rather than re-typing a 10-digit number.
//
// Low sensitivity (a number the driver just typed on this device); best-effort
// (private mode / quota simply skips it). Deliberately NOT cleared on sign-out —
// the whole point is to prefill the next sign-in.
const KEY = 'last_phone';
const IN_RE = /[^\d]/g;
const TEN_RE = /^[6-9]\d{9}$/;

/** Persist a phone (E.164 or bare 10-digit) as `+91XXXXXXXXXX`. No-op if invalid. */
export function rememberPhone(input: string): void {
  try {
    const digits = input.replace(IN_RE, '').slice(-10);
    if (TEN_RE.test(digits)) localStorage.setItem(KEY, `+91${digits}`);
  } catch {
    /* private mode / quota — prefill is best-effort */
  }
}

/** The remembered number as bare 10 digits for the input field, or '' if none. */
export function recallPhone(): string {
  try {
    return localStorage.getItem(KEY)?.replace(/^\+91/, '') ?? '';
  } catch {
    return '';
  }
}
